import React, { useState, useEffect, useContext,useCallback, Fragment } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
// import CarnivalForm from './carnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import ExistingProjectList from './existingProjectList';
import Supply from 'pages/sales/createLead/supply/supply';
import AddProjectOnboardingForm from "../ProjectOnboardingAddForm";
import {createProjectOnboarding} from "../../../../services/redux/sales/projectOnboarding/action";
import SearchLocation from 'components/sales/searchLocation/searchLocation';


const OnboardProject = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  getLeadInfraId,
  leadInfraId,
  saveCarnival,
  getCarnivalDataForUpdation,
  carnivalData,
  updateCarnivalData,
  getExistingProjectList,
  existingProjectList,
  LeadSource,
  pocType,
  leadCategories,
  locationCity,
  locationZone,
  locationArea,
  locationType,
  locationPinCode,
  locationState,
  createSupplyLead,
  pocSiteType,
  pocSubSiteType,
  pocSubSiteTypeData,
  getSupplyDropDown,
  getCurrentLocation,
  supDropDownData,
  cities,
  zones,
  areas,
  locTypesData,
  pincodeData,
  rwaTenureFun,
  rwaTenureData,
  appartmentDropDown,
  getApartmentDropDown,
  latlng,
  toastMsg,
  BulkUploadLead,
  getSampleFileLead,
  sampleData,
  createProjectOnboarding,
  getCorporateDropDown,
  corDropDownData,
  supplyNameFun,
  splNameData,
  documentUploadUrl,
  documentUrlData,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [infraIdMissingModal, setIsInfraIdMissingModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [showProjectListPopup, setShowProjectListPopup] = useState(false);
  const [projectType, setProjectType] = useState(null);
  const [projectSubType, setProjectSubType] = useState(null);
  const [showAddForm, setAddForm] = useState(false);
  const [isEnable, setIsEnable] = useState(true);
  const [optOption, setOptOption] = useState({
    address2: '',
    currentLocation: '',
  });
  const [isInputError, setIsInputError] = useState({
    latError: false,
    longError: false,
    pinError: false,
    crl: false,
    isPinNotFound: false,
  });

  const inputs = {
    project_type: '',
    project_name: '',
    lat: '',
    lng: ''
    };
    const [formData, setData] = useState(inputs);

    useEffect(() => {
      (async () => {
        setIsLoading(true);
        await getSupplyDropDown();
        setIsLoading(false);
      })();
    }, [getSupplyDropDown]);
  
  const handleSubmit = () => {
  };
  const checkInfraId = () => {
    if (handleValidateObj(formData) !== false ){
        (async () => {
              let res = await getExistingProjectList(formData);
              setShowProjectListPopup(true);
            })();
    } else {
        toast.error('Please fill all the fields.');
    }
    };

  const handleModalHide2 = () => {
    setIsInfraIdMissingModal(false);
    history.push(`${baseUrl}/brand-activation/conduct-carnival/carnival`);
  };

  const addNewProject = () => {
    setShowProjectListPopup(false);
      setAddForm(true)
    if (formData.project_type != '') {
      if(formData.project_type > 2){
        setProjectType(4);
      }else{
        setProjectType(formData.project_type);
      }
      setProjectSubType(formData.project_type);
    }
  }
  const hideProject = () => {
    setShowProjectListPopup(false);
  }

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCorporateDropDown();
      setIsLoading(false);
    })();
  }, [getCorporateDropDown]);

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submit}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  const handleCurrentLocationBlur = (latlng = null) => {
    if (latlng !== null && latlng !== undefined) {
      const { lat, lng } = latlng;
      console.log(latlng);
      setData({ ...formData, lat: lat, lng: lng });
      setIsEnable(true);
    }
    if (latlng === null) {
      setIsEnable(false);
      // setlocationData({ ...locationData, isLat: "", isLong: "" });
    }
  };

  const handleCurrentLocationChange = (value) => {
    setOptOption({ ...optOption, currentLocation: value });
    localStorage.setItem('currentLocation', value);
  };

  return (
    <Layout
      title={localization.projectOnboarding}
      // Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/project-onboarding/list`}
    >
    <FormSection title={localization.projectSearch}>
        <div className="row">
            <div className="col-md-3 col-sm-12">
                <DropDownInput
                    label={localization.projectType}
                    data={[
                        { id: 1, name: 'Corporate' },
                        { id: 2, name: 'Society' },
                        { id: 3, name: 'Mall' },
                        { id: 5, name: 'Hotel' },
                        { id: 6, name: 'Public Parking' },
                        { id: 7, name: 'Banquet' },
                        { id: 8, name: 'Hospital' },
                        { id: 9, name: 'Super Tag' },
                        // { id: 4, name: 'Other' },
                        
                    ]}
                    // getValueById={filterFieldsData?.status}
                    getIdValue={(val) =>
                        setData({ ...formData, project_type: val.id })
                    }
                />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    // value={formData.subject}
                    label={localization.projectName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, project_name: value })}
                    isStarRequired={true}
                    fullWidth
                    maxLength={50}
                />
            </div>
            {console.log(optOption)}
            <div className='col-md-3'>
              <SearchLocation
                handleCurrentLocationBlur={handleCurrentLocationBlur}
                isError={isInputError.crl}
                value={optOption.currentLocation}
                handleCurrentLocationChange={handleCurrentLocationChange}
              />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lat}
                    label={localization.lat}
                    errorMsg={localization.requiredLatitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lat: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
            <div className="col-md-3 col-sm-12">
                <ConstantInput
                    value={formData.lng}
                    label={localization.lng}
                    errorMsg={localization.requiredLongitude}
                    type="text"
                    required
                    handleChange={(value) => setData({ ...formData, lng: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>
            <div className="col-md-2 col-sm-5">
                <button className="btn btn-sm btn-primary" onClick={checkInfraId}>Search Project</button>
            </div>
        </div>
        
    </FormSection>
    {showAddForm &&
    // <FormSection title={localization.projectDetails}>
    <div className="mt-3">
            
                <AddProjectOnboardingForm
                    locationCity={locationCity}
                    cities={cities}
                    locationZone={locationZone}
                    zones={zones}
                    locationArea={locationArea}
                    areas={areas}
                    locationType={locationType}
                    locTypesData={locTypesData}
                    locationState={locationState}
                    locationPinCode={locationPinCode}
                    pincodeData={pincodeData}
                    rwaTenureFun={rwaTenureFun}
                    rwaTenureData={rwaTenureData}
                    appartmentDropDown={appartmentDropDown}
                    getApartmentDropDown={getApartmentDropDown}
                    getCurrentLocation={getCurrentLocation}
                    latlng={latlng}
                    toastMsg={toastMsg}
                    BulkUploadLead={BulkUploadLead}
                    getSampleFileLead={getSampleFileLead}
                    sampleData={sampleData}
                    projectType={projectType}
                    projectSubType={projectSubType}
                    project_name={formData.project_name}
                    lat={formData.lat}
                    lng={formData.lng}
                    createProjectOnboarding={createProjectOnboarding}
                    corDropDownData={corDropDownData}
                    supplyNameFun={supplyNameFun}
                    splNameData={splNameData}
                    supDropDownData = {supDropDownData}
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    pocSubSiteTypeData={pocSubSiteTypeData}
                    pocSubSiteType={pocSubSiteType}
                    currentLocation={optOption.currentLocation}
                />
            
        </div>
    // </FormSection>
    }
  
    
    <ExistingProjectList
        showProjectListPopup={showProjectListPopup}
        onClosePopup={() => addNewProject(false)}
        onCloseHidePopup={() => hideProject(false)}
        
        existingProjectList = {existingProjectList?.projects}
        
    />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          {/* <h5>{meetingData?.meetingDetails?.isEdit == 1 ? localization.carnivalUpdateSuccess : localization.carnivalSuccess}</h5> */}
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToCarnivalListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

OnboardProject.propTypes = {};

export default OnboardProject;
